/* */
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getListOffer, setFilterDefaultOffers, changeFilterOffers } = actions;

export default () => {
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();

  const handleFilterOffers = useCallback((filters = {}, resetForm = () => {}) => {
    dispatch(changeFilterOffers(filters, resetForm));
  }, []);

  useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId) {
      dispatch(getListOffer());
    }

    return () => {
      dispatch(setFilterDefaultOffers());
    };
  }, [authReducer.isLogin]);

  return [handleFilterOffers];
};
